import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "..";
import type { SSIV2OverviewResponse, SsiV2RequestParams } from "./ssiV2API.types";

export const ssiV2API = createApi({
  reducerPath: "ssiV2API",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getSsiV2Overview: builder.query<SSIV2OverviewResponse, SsiV2RequestParams>({
      query: (params) => {
        const { affAbo, locale, period, isoCountryCode, isoCurrencyCode } = params;
        const queryParams = new URLSearchParams({
          Locale: locale,
          AffAbo: affAbo,
          Period: period,
          IsoCountryCode: isoCountryCode,
          IsoCurrencyCode: isoCurrencyCode,
        });

        return `/incentives-v2/api/ssi/v2/overview?${queryParams}`;
      },
    }),
  }),
});

export const { useGetSsiV2OverviewQuery } = ssiV2API;
